









































import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'

@Component
export default class DeactivateBrandPopup extends Vue {
  @Prop() popupId!: string

  SendEmailToIOSUsers (val: any) {
    this.$http
      .post('email-logs', { 'device_type': val })
      .then((response) => {
        this.$notify({ text: 'Email sent to all ' + val + ' users', type: 'success' })
        let clearBlockedUsersPopupCloseButton: HTMLElement = this.$refs.clearBlockedUsersPopupCloseButton as HTMLElement
        clearBlockedUsersPopupCloseButton.click()
      })
  }
}
